<template>
  <div
    class="schedule_group_matchList"
    :id="`matchList_${data.icon}`"
    :style="{ paddingBottom: `${pbPx}px` }"
    v-show="isShow"
  >
    <div class="match_label">
      <span class="label_textArea">
        <span class="labelIcon" v-if="isShowLabelIcon && data.icon">
          <img
            :src="
              currSid === 'ASG2026'
                ? `/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/ASG2026/${data.icon}.png`
                : `/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/sportsIcon/${data.icon}.png`
            "
          />
        </span>
        <span
          :class="[data.label && data.label.length === 2 ? 'letterSpa' : '']"
          v-text="_valPerFormatHandler(data.label)"
        ></span>
      </span>
    </div>
    <div class="match_list">
      <slot name="matchList"></slot>
    </div>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'schedule_group_matchList',
  mixins: [cup_base_data_mixin],
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          label: '',
          icon: '',
          list: [],
        }
        // return {
        //   label: '艺术体操',
        //   icon: 'GRY',
        //   list: [
        //     {
        //       matchId: 1,
        //       matchName: '篮球·男子预赛A组',
        //       type: 'combat', //对抗类或非对抗类
        //       isChina: true,
        //       isGold: false,
        //       medalist: [
        //         {
        //           playerId: '1',
        //           playerName: '张三',
        //           medalType: 'GOLD',
        //           delegationName: '中国',
        //           delegationLogo: '',
        //         },
        //         {
        //           playerId: '2',
        //           playerName: '张三',
        //           medalType: 'GOLD',
        //           delegationName: '中国',
        //           delegationLogo: '',
        //         },
        //         {
        //           playerId: '3',
        //           playerName: '张三',
        //           medalType: 'GOLD',
        //           delegationName: '中国',
        //           delegationLogo: '',
        //         },
        //       ],
        //       disciplineName: '艺术体操',
        //       disciplineId: 'GRY',
        //       matchStatus: 'Playing',
        //       matchTime: '12:30',
        //       venueName: '场馆名称场馆名称1',
        //       homeName: '主队',
        //       homeLogo: '',
        //       homeScore: 3,
        //       awayName: '客队',
        //       awayLogo: '',
        //       awayScore: 2,
        //     },
        //     {
        //       matchId: 2,
        //       matchName:
        //         '篮球·男子预赛A组篮球·男子预赛A组篮球·男子预赛A组篮球·男子预赛A组',
        //       type: 'uncombat', //对抗类或非对抗类
        //       isChina: true,
        //       isGold: true,
        //       medalist: [
        //         {
        //           playerId: '1',
        //           playerName: '张三',
        //           medalType: 'GOLD',
        //           delegationName: '中国',
        //           delegationLogo: '',
        //         },
        //         {
        //           playerId: '2',
        //           playerName: '张三',
        //           medalType: 'GOLD',
        //           delegationName: '中国',
        //           delegationLogo: '',
        //         },
        //         {
        //           playerId: '3',
        //           playerName: '张三',
        //           medalType: 'GOLD',
        //           delegationName: '中国',
        //           delegationLogo: '',
        //         },
        //       ],
        //       disciplineName: '艺术体操',
        //       disciplineId: 'GRY',
        //       matchStatus: 'Played',
        //       matchTime: '12:30',
        //       venueName: '场馆名称场馆名称1',
        //       homeName: '主队',
        //       homeLogo: '',
        //       homeScore: 3,
        //       awayName: '客队',
        //       awayLogo: '',
        //       awayScore: 2,
        //     },
        //     {
        //       matchId: 3,
        //       matchName:
        //         '篮球·男子预赛A组篮球·男子预赛A组篮球·男子预赛A组篮球·男子预赛A组',
        //       type: 'uncombat', //对抗类或非对抗类
        //       isChina: true,
        //       isGold: true,
        //       medalist: [
        //         {
        //           playerId: '1',
        //           playerName: '张三',
        //           medalType: 'GOLD',
        //           delegationName: '中国',
        //           delegationLogo: '',
        //         },
        //         {
        //           playerId: '2',
        //           playerName: '张三',
        //           medalType: 'GOLD',
        //           delegationName: '中国',
        //           delegationLogo: '',
        //         },
        //         {
        //           playerId: '3',
        //           playerName: '张三',
        //           medalType: 'GOLD',
        //           delegationName: '中国',
        //           delegationLogo: '',
        //         },
        //       ],
        //       disciplineName: '艺术体操',
        //       disciplineId: 'GRY',
        //       matchStatus: 'Played',
        //       matchTime: '12:30',
        //       venueName: '场馆名称场馆名称1',
        //       homeName: '主队',
        //       homeLogo: '',
        //       homeScore: 3,
        //       awayName: '客队',
        //       awayLogo: '',
        //       awayScore: 2,
        //     },
        //     {
        //       matchId: 4,
        //       matchName:
        //         '篮球·男子预赛A组篮球·男子预赛A组篮球·男子预赛A组篮球·男子预赛A组',
        //       type: 'uncombat', //对抗类或非对抗类
        //       isChina: true,
        //       isGold: true,
        //       medalist: [
        //         {
        //           playerId: '1',
        //           playerName: '张三',
        //           medalType: 'GOLD',
        //           delegationName: '中国',
        //           delegationLogo: '',
        //         },
        //         {
        //           playerId: '2',
        //           playerName: '张三',
        //           medalType: 'GOLD',
        //           delegationName: '中国',
        //           delegationLogo: '',
        //         },
        //         {
        //           playerId: '3',
        //           playerName: '张三',
        //           medalType: 'GOLD',
        //           delegationName: '中国',
        //           delegationLogo: '',
        //         },
        //       ],
        //       disciplineName: '艺术体操',
        //       disciplineId: 'GRY',
        //       matchStatus: 'Played',
        //       matchTime: '12:30',
        //       venueName: '场馆名称场馆名称1',
        //       homeName: '主队',
        //       homeLogo: '',
        //       homeScore: 3,
        //       awayName: '客队',
        //       awayLogo: '',
        //       awayScore: 2,
        //     },
        //   ],
        // }
      },
    },
    pbPx: {
      type: Number,
      default: () => {
        return 40
      },
    },
    isShowLabelIcon: {
      type: Boolean,
      default: true,
    },
    filterCondition: {
      // 目前只用在足球世界杯筛选 字母 和 球队 时使用
      type: [String, Number],
      default: '-1',
    },
    // detailPathName: {
    //   type: String,
    //   default: '',
    // },
    // chooseState: {
    //   type: String,
    //   default: 'default', //['default', 'choose']
    // },
  },
  data() {
    return {
      sportsTypeArr: ['combat', 'uncombat'],
      matchStatusObj: {
        CANCELLED: 3,
        DELAYED: 3,
        FINISHED: 2,
        GETTING_READY: 0,
        INTERRUPTED: 3,
        POSTPONED: 3,
        RESCHEDULED: 3,
        RUNNING: 1,
        SCHEDULED: 0,
        SCHEDULED_BREAK: 1,
        UNSCHEDULED: 2,
      },
      matchStatusColorArr: [
        {
          colorClass: 'unstart',
          key: ['GETTING_READY', 'SCHEDULED'],
          name: ['已就绪', '按日程计划'],
        },
        {
          colorClass: 'playing',
          key: ['RUNNING', 'SCHEDULED_BREAK'],
          name: ['比赛中', '中场休息'],
        },
        {
          colorClass: 'finished',
          key: ['FINISHED', 'UNSCHEDULED'],
          name: ['已结束', '未安排'],
        },
        {
          colorClass: 'other',
          key: ['CANCELLED', 'DELAYED', 'INTERRUPTED', 'RESCHEDULED'],
          name: ['已取消', '延误', '中断', '推迟', '改期'],
        },
      ],
    }
    // CANCELLED 已取消
    // DELAYED 延误
    // FINISHED 已结束
    // GETTING_READY 已就绪
    // INTERRUPTED 中断
    // POSTPONED 推迟
    // RESCHEDULED 改期
    // RUNNING 比赛中
    // SCHEDULED 按日程计划
    // SCHEDULED_BREAK 中场休息
    // UNSCHEDULED 未安排
  },
  computed: {
    isShow() {
      if (this.filterCondition === '-1') {
        // 不传该参数时，默认展示
        return true
      }
      const filterCondition = this.filterCondition
      const list = this.data.list
      let filterConditionArr = []
      if (filterCondition && filterCondition.indexOf('_') > -1) {
        filterConditionArr = filterCondition.split('_')
      }

      if (filterConditionArr[0] == 'stage') {
        if (filterConditionArr[1] == '1') {
          return true
        } else {
          return false
        }
      }
      if (filterConditionArr[0] == 'team') {
        if (filterConditionArr[1] == '-1' || filterConditionArr[1] == '') {
          return true
        } else {
          let flag = false
          for (let i = 0; i < list.length; i++) {
            const item = list[i]
            if (
              item.awayId == filterConditionArr[1] ||
              item.homeId == filterConditionArr[1]
            ) {
              flag = true
              break
            }
          }
          return flag
        }
      }
      return false
    },
  },
  methods: {
    matchStatusToMatchCN(matchStatus) {
      let index = this.matchStatusObj[matchStatus]
      let item = this.matchStatusColorArr[index]
      let matchCN = item.name[item.key.indexOf(matchStatus)]
      return this._valPerFormatHandler(matchCN)
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.mixtmt_pc,
.mixtmt_ipad {
  .schedule_group_matchList {
    width: 100%;
    height: auto;
    .match_label {
      position: relative;
      width: 100%;
      height: 3.472vw;
      background-image: var(--mixtmt_scheduleMatchList_dateBg);
      background-size: 100% auto;
      background-position: left top;
      background-repeat: no-repeat;

      .label_textArea {
        position: absolute;
        left: 0;
        top: 50%;
        z-index: 2;
        width: 21.55%;
        font-size: 1.38vw;
        transform: translateY(-50%);
        color: var(--mixtmt_whiteColor);
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        .labelIcon {
          width: 2.778vw;
          height: 2.778vw;
          border: 1.5px solid var(--mixtmt_whiteColor);
          border-radius: 50%;
          overflow: hidden;
          margin-right: 0.694vw;
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        & .letterSpa {
          letter-spacing: 0.4vw;
        }
      }
    }
    .match_list {
      width: 100%;
      height: auto;
      .match_list_item {
        position: relative;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: flex-start;
        height: auto;
        width: 100%;
        padding: 0.694vw 1.388vw;
        color: var(--mixtmt_greyColor3);
        border-bottom: 1px solid var(--mixtmt_greyColor5);
        transition: padding 0.3s linear;
        &.choose {
          padding: 0.694vw 1.388vw 0.694vw 2.776vw;
          .item_absChoose {
            width: 2.776vw;
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            .checkbox_item {
              width: 1.388vw;
              height: 1.388vw;
              border-radius: 0.208vw;
              border: 1px solid var(--mixtmt_subColor1_1);
              display: flex;
              display: -webkit-flex;
              justify-content: center;
              align-items: center;
              background-color: var(--mixtmt_whiteColor);
              /* &.act {
                background-color: var(--mixtmt_subColor1_1);
                color: var(--mixtmt_whiteColor);
              } */
              svg {
                opacity: 0;
                fill: var(--mixtmt_whiteColor);
                transition: all 0.3s linear;
              }
            }
          }
          &.chooseAct {
            .checkbox_item {
              background-color: var(--mixtmt_subColor1_1);
              svg {
                opacity: 1;
              }
            }
          }
        }
        .matchLeft_colum1,
        .matchLeft_colum2,
        .matchCenter_colum1,
        .matchCenter_colum2 {
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;
          align-items: flex-start;
          flex-direction: column;
          height: auto;
        }
        .matchLeft_colum1_row1,
        .matchLeft_colum2_row1,
        .matchCenter_colum1_row,
        .matchCenter_colum2_row {
          margin-bottom: 0.347vw;
        }
        .item_matchLeft {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          width: 44.53vw;
          .matchLeft_colum1 {
            width: calc(100% - 32.3vw);
            .matchLeft_colum1_row1 {
              width: 100%;
              font-size: 1.388vw;
              line-height: 2.083vw;
              height: 2.083vw;
              font-weight: bold;
            }
            .matchLeft_colum1_row2 {
              display: flex;
              display: -webkit-flex;
              justify-content: flex-start;
              align-items: center;
              width: 100%;
              height: 2.083vw;
              .national_icon {
                padding-right: 0.694vw;
                width: 2.083vw;
                height: 0.903vw;
                overflow: hidden;
                background-image: var(--mixtmt_china_square_icon);
                background-size: auto 100%;
                background-repeat: no-repeat;
                background-position: left center;
              }
              .medal_icon {
                padding-right: 0.694vw;
                width: 1.805vw;
                height: 1.11vw;
                overflow: hidden;
                background-image: var(--mixtmt_medal_gold_icon);
                background-size: auto 100%;
                background-repeat: no-repeat;
                background-position: left center;
              }
            }
          }
          .matchLeft_colum2 {
            width: 32.3vw;
            .matchLeft_colum2_row1 {
              width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 1.38vw;
              line-height: 2.083vw;
              height: 2.083vw;
              font-weight: bold;
            }
            .matchLeft_colum2_row2 {
              display: flex;
              display: -webkit-flex;
              justify-content: flex-start;
              align-items: center;
              width: 100%;
              height: 2.083vw;
              .sportHall_icon {
                width: 1.11vw;
                height: 1.11vw;
                background-image: var(
                  --mixtmt_scheduleMatchList_sportHall_icon
                );
                background-size: 100% auto;
                background-position: 0 0;
                background-repeat: no-repeat;
              }
              .sportHall_name {
                width: calc(100% - 1.11vw);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 1.11vw;
                line-height: 2.083vw;
                padding: 0 0.486vw;
                color: var(--mixtmt_greyColor2);
              }
            }
          }
        }
        .item_matchCenter {
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;
          align-items: center;
          width: 20.75vw;
          .matchCenter_colum1 {
            width: 15.98vw;
            .matchCenter_colum1_row {
              width: 100%;
              height: 2.083vw;
              display: flex;
              display: -webkit-flex;
              justify-content: flex-start;
              align-items: center;
              .delegationLogo {
                width: 1.38vw;
                height: 1.18vw;
                overflow: hidden;
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: contain;
                  display: block;
                }
              }
              .delegationName {
                width: calc(100% - 1.38vw);
                padding-left: 0.972vw;
                font-size: 0.972vw;
                font-weight: bold;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
          .matchCenter_colum2 {
            width: calc(100% - 15.98vw);
            padding-left: 0.694vw;
            .matchCenter_colum2_row {
              width: 100%;
              height: 2.083vw;
              font-size: 0.972vw;
              line-height: 2.083vw;
              font-weight: bold;
              text-align: left;
              padding-right: 0.347vw;
            }
          }
          &.uncombat {
            .matchCenter_colum2_row {
              display: flex;
              display: -webkit-flex;
              justify-content: flex-start;
              align-items: center;
              padding-right: 0;
              .medalIcon {
                width: 1.11vw;
                height: 1.11vw;
                overflow: hidden;
                background-size: auto 100%;
                background-repeat: no-repeat;
                background-position: left center;
                &.ME_GOLD {
                  background-image: var(--mixtmt_medal_gold_icon);
                }
                &.ME_SILVER {
                  background-image: var(--mixtmt_medal_silver_icon);
                }
                &.ME_BRONZE {
                  background-image: var(--mixtmt_medal_bronze_icon);
                }
              }
            }
          }
        }
        .item_matchRight {
          position: absolute;
          right: 1.388vw;
          top: 50%;
          z-index: 10;
          transform: translateY(-50%);
          width: 6.94vw;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-end;
          align-items: center;
          .matchRight_status {
            width: 6.94vw;
            height: 2.083vw;
            line-height: 2.083vw;
            font-size: 0.972vw;
            text-align: center;
            border-radius: 0.278vw;
            &.unstart {
              color: var(--mixtmt_subColor3_1);
              border: 1px solid var(--mixtmt_subColor3_1);
            }
            &.playing {
              color: var(--mixtmt_subColor5_1);
              border: 1px solid var(--mixtmt_subColor5_1);
            }
            &.finished {
              color: var(--mixtmt_greyColor2);
              border: 1px solid var(--mixtmt_greyColor2);
            }
            &.other {
              color: var(--mixtmt_subColor1_1);
              border: 1px solid var(--mixtmt_subColor1_1);
            }
          }
        }
        .item_absChoose {
          position: absolute;
          left: 0;
          top: 0;
          z-index: 2;
          width: 0;
          height: 100%;
          transition: width 0.3s linear;
        }
      }
    }
  }
}

.mixtmt_pc {
  .schedule_group_matchList {
    .match_list {
      .match_list_item {
        cursor: pointer;
        &:hover,
        &.choose.chooseAct {
          background-color: var(--mixtmt_mainColor);
          color: var(--mixtmt_whiteColor);
          .item_matchCenter {
          }
          .item_matchRight {
            .matchRight_status.unstart {
              color: var(--mixtmt_whiteColor);
              background-color: var(--mixtmt_subColor3_1);
              border: 1px solid var(--mixtmt_subColor3_1);
            }
            .matchRight_status.playing {
              color: var(--mixtmt_whiteColor);
              background-color: var(--mixtmt_subColor5_1);
              border: 1px solid var(--mixtmt_subColor5_1);
            }
            .matchRight_status.finished {
              opacity: 0.45;
              color: var(--mixtmt_mainColor);
              background-color: var(--mixtmt_whiteColor);
              border: 1px solid var(--mixtmt_whiteColor);
            }
            .matchRight_status.other {
              color: var(--mixtmt_whiteColor);
              background-color: var(--mixtmt_subColor1_1);
              border: 1px solid var(--mixtmt_subColor1_1);
            }
          }
          .item_matchLeft {
            .matchLeft_colum2 {
              .matchLeft_colum2_row2 {
                .sportHall_name {
                  color: var(--mixtmt_whiteColor);
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
